import React, { useState } from "react";
import OcButton from "../components/OcButton";
import "./Faq.scss";

import iconPlus from "../../../assets/images/home/08-faq/icon-plus.svg";
import iconClose from "../../../assets/images/home/08-faq/icon-close.svg";
import xLogo from "../../../assets/images/home/08-faq/x-logo.svg";

const ITEMS = [
  {
    q: "What is Open Campus?",
    a: "Open Campus is an AI-first platform for learning and growth. It brings together your personal AI Minds, practical AI tools, partner mini-apps, and verifiable credentials in one connected place.",
  },
  {
    q: "What is a Mind?",
    a: "A Mind is your persistent AI partner. It remembers your context, works toward your goals, and helps you across learning, career, and everyday tasks.",
  },
  {
    q: "How is OC Minds different from ChatGPT?",
    a: "Unlike a general chatbot, a Mind is persistent and personal. It remembers your goals and context, works in the background, and connects to Open Campus tools, mini-apps, and your credentials.",
  },
  {
    q: "What is OCID?",
    a: "OCID is your Open Campus ID, a portable education identity that lets you own and prove your achievements and credentials across the ecosystem.",
  },
  {
    q: "Is Open Campus free?",
    a: "Yes, you can get started for free. Some advanced features and partner programs may have their own pricing.",
  },
  {
    q: "When does it launch?",
    a: "Open Campus is currently in beta, with new features rolling out regularly. Join the waitlist to be the first to know about launches.",
  },
  {
    q: "Who's the team behind Open Campus?",
    a: "Open Campus is built by a global community and backed by partners including Animoca Brands, alongside educators, builders, and ecosystem partners worldwide.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(1);

  return (
    <section className="faq">
      <div className="faq__inner">
        <div className="faq__intro">
          <div className="faq__intro-text">
            <h2>You have questions, we have answers.</h2>
            <p>
              Here are some questions that our users frequently ask regarding our product, what we
              provide and how we engage with our partners and the education community. We hope these
              answers can help you get started. Feel free to connect with us directly through our
              various channels if there are still questions that you need answered.
            </p>
          </div>
          <div className="faq__actions">
            {/* Figma: outline "Contact us" first, filled "Connect with us on X" second */}
            <OcButton variant="outline" href="mailto:help@opencampus.xyz">
              Contact us
            </OcButton>
            <OcButton
              className="faq__x-btn"
              variant="primary"
              href="https://twitter.com/opencampus_xyz"
              target="_blank"
              showArrow={false}
            >
              Connect with us on
              <img className="faq__x-logo" src={xLogo} alt="X" />
            </OcButton>
          </div>
        </div>

        <div className="faq__list">
          {ITEMS.map((item, i) => {
            const isOpen = i === open;
            return (
              <div className={`faq-item${isOpen ? " faq-item--open" : ""}`} key={item.q}>
                <button className="faq-item__head" onClick={() => setOpen(isOpen ? -1 : i)} aria-expanded={isOpen}>
                  <span className="faq-item__text">
                    <span className="faq-item__q">{item.q}</span>
                    <span className="faq-item__body" aria-hidden={!isOpen}>
                      <span className="faq-item__body-inner">
                        <span className="faq-item__a">{item.a}</span>
                      </span>
                    </span>
                  </span>
                  <span className="faq-item__icon" aria-hidden="true">
                    <img className="faq-item__icon-plus" src={iconPlus} alt="" />
                    <img className="faq-item__icon-close" src={iconClose} alt="" />
                  </span>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
